import classnames from 'classnames';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFeedKeyboardInteractions } from 'palette/ProductCard/hooks/useFeedKeyboardInteractions';
import { useConfig } from '@common/Hooks/useConfig';
import { setOverlay } from '@common/Listing/actions/listingActions';
import { InlistingBanners } from '@common/Listing/components';
import {
    listingGridSelector,
    selectListingProductsInfo,
    selectListingPageInfo
} from '@common/Listing/selectors/ListingSelector';
import { trackProductImpressions } from '@common/Tracking';
import { isBooztAndWebshop } from '@helpers/env';
import './ProductListWrap.scss';

export function ProductListWrap({
    isOverlayActive, numberOfItems, children
}) {
    const config = useConfig();
    const dispatch = useDispatch();
    const { gridViewFromConfig, gridView } = useSelector(listingGridSelector);
    const { productsPerPage } = useSelector(selectListingProductsInfo);
    const { productsGroup } = useSelector(selectListingPageInfo);
    const currentPage = useSelector(({ pagination }) => pagination.currentPage);
    const selectedGrid = gridViewFromConfig ?? gridView;

    const containerRef = useFeedKeyboardInteractions();

    useEffect(() => {
        if (isBooztAndWebshop(config)) {
            trackProductImpressions(containerRef.current);
        }
    }, [config, containerRef]);

    return (
        <ul
            ref={containerRef}
            aria-label="products list"
            className={classnames(
                'palette-cards-grid',
                'product-list-wrap',
                {
                    [`palette-cards-grid--${selectedGrid}`]: selectedGrid
                }
            )}
            data-current-page={currentPage}
            data-products-group={productsGroup}
            data-products-per-page={productsPerPage}
            data-total-products={numberOfItems}
            role="feed"
        >
            <div className={classnames('product-list-wrap__overlay', {
                'product-list-wrap__overlay--hidden': !isOverlayActive
            })}
            />
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
            <div
                className={classnames('product-list-wrap__overlay product-list-wrap__overlay--clear', {
                    'product-list-wrap__overlay--hidden': !isOverlayActive
                })}
                onClick={() => dispatch(setOverlay(false))}
            />
            <InlistingBanners containerElement={containerRef} />
            {children}
        </ul>
    );
}
